import { Injectable } from '@angular/core';
import { ApiService } from 'src/app/shared';
import { ImportRegistrationsConfigDto } from '../../import/import-registrations/import-registations-config.dto';

@Injectable({
  providedIn: 'root',
})
export class ImportRegistrationService {
  constructor(private _apiService: ApiService) {}

  importRegistrations(file: File, importConfig: ImportRegistrationsConfigDto) {
    const data = new FormData();
    data.append('file', file, file.name);
    data.append('configJson', JSON.stringify(importConfig));
    return this._apiService.postRaw(`Event/Import/Registration`, data);
  }
}
